import React, { useState } from 'react';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const ShipList = ({ data, setCurrentPage, limit, history, onSave }) => {
    const { ships, total, page, assigned } = data;
    const [assignedVessles, setAssignedVessels] = useState(assigned)
    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Vessel Details</th>
                            <th>Owner Details</th>
                            <th>Other Details</th>
                            <th>Status</th>
                            <th>Modified By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ships?.length > 0 ? (
                            ships.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type='checkbox'
                                            checked={assignedVessles.includes(item.ID)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                const shipId = item.ID;

                                                setAssignedVessels((prev) => {
                                                    if (checked) {
                                                        // Add if not already present
                                                        return [...prev, shipId];
                                                    } else {
                                                        // Remove if unchecked
                                                        return prev.filter(id => id !== shipId);
                                                    }
                                                });
                                            }}
                                        />

                                    </td>
                                    <td>
                                        <h5 className="font-size-14 mb-1">
                                            <a href="javascript:void(0)" className="text-dark">
                                                {item.SHIP_NAME} - ({item.SHIP_CODE})
                                            </a>
                                        </h5>
                                        <p
                                            className="text-muted mb-0"
                                            style={{ color: "#00add2 !important" }}
                                        >
                                            Ship Type :{item.SHIP_TYPE_NAME || '-'}
                                        </p>
                                        <p
                                            className="text-muted mb-0"
                                            style={{ color: "#00add2 !important" }}
                                        >
                                            Yard :{item.YARD_NAME || '-'}
                                        </p>
                                        <p className="text-muted mb-0">
                                            <span style={{ color: "#f46a6a" }}>Build Date</span> |
                                            {item.BUILD_DATE || '-'}{" "}
                                        </p>
                                        <p className="text-muted mb-0">
                                            <span style={{ color: "#f46a6a" }}>Delivery Date</span> |
                                            {item.DELIVERY_DATE || '-'}{" "}
                                        </p>
                                    </td>

                                    <td>
                                        <h5 className="font-size-14 mb-1">
                                            <a href="javascript:void(0);" className="text-dark">
                                                Owner Name : {item.SHIP_OWNER_NAME}
                                            </a>
                                        </h5>
                                        <p className="text-muted mb-0">
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#2b5a7e" }}>
                                                    {item.SHIP_OWNER_ADDRESS}
                                                </span>
                                            </a>
                                        </p>
                                    </td>
                                    <td style={{ padding: '12px', verticalAlign: 'top' }}>
                                        <h5 style={{ fontSize: '14px', marginBottom: '6px', fontWeight: 500, color: '#212529' }}>
                                            Unit Manager:&nbsp;
                                            <span style={{ fontWeight: 400 }}>{item.UNIT_MANAGER_NAME || '-'}</span>
                                        </h5>
                                        <h5 style={{ fontSize: '14px', marginBottom: '6px', fontWeight: 500, color: '#212529' }}>
                                            Chief Engineer:&nbsp;
                                            <span style={{ fontWeight: 400 }}>{item.CHIEF_ENGINEER_NAME || '-'}</span>
                                        </h5>
                                        <h5 style={{ fontSize: '14px', marginBottom: '0', fontWeight: 500, color: '#212529' }}>
                                            Technical Superintendent:&nbsp;
                                            <span style={{ fontWeight: 400 }}>{item.TECHNICAL_SUPRITENDENT_NAME || '-'}</span>
                                        </h5>
                                    </td>

                                    <td>
                                        <span
                                            className={`badge rounded-pill ${item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'
                                                }`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="11" className="text-center">
                                    No Ships found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
            <div className="d-flex justify-content-end mt-3 gap-2">
                <button
                    className="btn btn-success me-2"
                    onClick={() => {
                        onSave(btoa(JSON.stringify(assignedVessles)));
                    }}
                >
                    Save
                </button>
                <button
                    className="btn btn-danger"
                    onClick={() => {
                        history.push(constant.Authedcomponent.listProject.url)
                    }}
                >
                    Cancel
                </button>
            </div>

        </React.Fragment>
    );
};

export default withRouter(ShipList);
